import { Navigate, useNavigate, useParams } from "react-router-dom";
import { H5StockDetailPanel } from "./H5StockDetailPanel";

export default function StockDetailPage(): JSX.Element {
  const navigate = useNavigate();
  const { spaceId, stockCode: stockCodeParam } = useParams<{
    spaceId: string;
    stockCode: string;
  }>();
  const stockCode = decodeURIComponent(stockCodeParam ?? "").trim();

  if (!spaceId || !/^\d{8}$/.test(spaceId)) {
    return <Navigate to="/" replace />;
  }

  if (!stockCode) {
    return <Navigate to={`/space/${spaceId}/home`} replace />;
  }

  return <H5StockDetailPanel stockCode={stockCode} onBack={() => navigate(-1)} />;
}
